<script setup lang="ts">
interface IProps {
  show: boolean,
  link: string,
}

const props = withDefaults(defineProps<IProps>(), {
  show: false,
});

const emit = defineEmits(['clicked']);
</script>

<template>
  <div
      class="bg-gray-100 dark:bg-zinc-900 border-t border-gray-200 dark:border-zinc-800 z-[5] fixed bottom-0 left-0 right-0 transition-transform duration-500 text-white"
      :class="show ? 'translate-y-0' : 'translate-y-full'"
  >
    <div class="container py-3">
      <button
          @click.prevent="emit('clicked')"
          rel="nofollow"
          class="flex justify-center items-center gap-3 bg-fm-gradient hover:bg-fm-gradient-active rounded-xl py-2 px-5 !text-white w-full"
      >
              <span class="flex flex-col text-center">
                <span class="font-semibold leading-5">Get App for Free</span>
                <span class="font-light">to continue reading and more</span>
              </span>
        <span class="h-11 w-11 rounded-full text-white flex items-center justify-center" style="background: rgba(0, 0, 0, 0.18)">
                <icon name="fm:download" class="text-2xl" />
              </span>
      </button>
    </div>
  </div>
</template>